var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPin = function SvgIconPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.5 6.158c0 1.28-.652 2.839-1.62 4.396-.853 1.369-1.915 2.682-2.88 3.72-.965-1.038-2.027-2.351-2.88-3.72C4.153 8.997 3.5 7.438 3.5 6.158 3.5 3.57 5.53 1.5 8 1.5s4.5 2.07 4.5 4.658Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 6.158,
    fill: "currentColor",
    rx: 1.667,
    ry: 1.719
  })));
};
export { SvgIconPin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjUgNi4xNTc4OUMxMi41IDcuNDM4MTYgMTEuODQ4MSA4Ljk5NjkgMTAuODc5MSAxMC41NTRDMTAuMDI3MSAxMS45MjMgOC45NjQ2NSAxMy4yMzYyIDggMTQuMjczN0M3LjAzNTM2IDEzLjIzNjIgNS45NzI4OCAxMS45MjMgNS4xMjA5MyAxMC41NTRDNC4xNTE4NSA4Ljk5NjkgMy41IDcuNDM4MTYgMy41IDYuMTU3ODlDMy41IDMuNTcwNjQgNS41MjkyNiAxLjUgOCAxLjVDMTAuNDcwNyAxLjUgMTIuNSAzLjU3MDY0IDEyLjUgNi4xNTc4OVoiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CjxlbGxpcHNlIGN4PSI4LjAwMDA0IiBjeT0iNi4xNTc5IiByeD0iMS42NjY2NyIgcnk9IjEuNzE5MyIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";